import { color as foundationColor, effects as foundationEffects, size } from '../foundation';

const { neutral, primary } = foundationColor;

const selectionBase = {
  color: {
    off: {
      default: neutral[500],
      hover: neutral[600],
    },
    on: {
      default: primary[500],
      hover: primary[600],
    },
  },
  size: {
    xs: size[300],
    sm: size[350],
    md: size[400],
    lg: size[500],
  },
  state: {
    disabled: {
      bg: neutral[300],
      opacity: foundationEffects.opacity[40],
    },
  },
};

export const input = {
  selection: {
    checkbox: {
      color: {
        off: {
          default: selectionBase.color.off.default,
          hover: selectionBase.color.off.hover,
        },
        on: {
          default: selectionBase.color.on.default,
          hover: selectionBase.color.on.hover,
        },
      },
      size: {
        sm: selectionBase.size.sm,
        md: selectionBase.size.md,
        lg: selectionBase.size.lg,
      },
      state: {
        disabled: {
          bg: selectionBase.state.disabled.bg,
          opacity: selectionBase.state.disabled.opacity,
        },
      },
    },
    radio: {
      color: {
        off: {
          default: selectionBase.color.off.default,
          hover: selectionBase.color.off.hover,
        },
        on: {
          default: selectionBase.color.on.default,
          hover: selectionBase.color.on.hover,
        },
      },
      size: {
        sm: selectionBase.size.sm,
        md: selectionBase.size.md,
        lg: selectionBase.size.lg,
      },
      state: {
        disabled: {
          opacity: selectionBase.state.disabled.opacity,
        },
      },
    },
    toggle: {
      color: {
        off: {
          default: selectionBase.color.off.default,
          hover: selectionBase.color.off.hover,
        },
        on: {
          default: selectionBase.color.on.default,
          hover: selectionBase.color.on.hover,
        },
      },
      effects: {
        radius: '10px',
      },
      size: {
        button: {
          sm: selectionBase.size.xs,
          md: selectionBase.size.sm,
          lg: selectionBase.size.md,
        },
        track: {
          minWidth: {
            sm: size[700], 
            md: size[800], 
            lg: size[900], 
          },
        },
      },
      state: {
        disabled: {
          button: neutral[200],
          opacity: selectionBase.state.disabled.opacity,
        },
      },
    },
  },
};

export default input;